/* The mockup's `.share-pop`: head, body (form or created link, then the links), foot. */
.panel {
  display: flex;
  flex-direction: column;
  max-block-size: min(80vh, 640px);
}

.head {
  display: flex;
  align-items: baseline;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4) 0;
}

.title {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
  white-space: nowrap;
}

.meta {
  min-inline-size: 0;
  overflow: hidden;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  overflow-y: auto;
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.label {
  flex: none;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
}

.narrow {
  inline-size: 120px;
}

.wide {
  flex: 1;
  max-inline-size: 200px;
}

.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.select {
  block-size: var(--control-height);
  padding: 0 var(--space-2);
  border: 1px solid var(--border-control);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
  color: var(--text);
  font: inherit;
}

.select:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -1px;
}

/* "Crear enlace" spans the popover, as in the mockup. */
.submit {
  display: flex;
  flex-direction: column;
}

.notice {
  display: flex;
  gap: var(--space-2);
  align-items: flex-start;
  margin: 0;
  padding: 10px 12px;
  border-radius: var(--radius-control);
  background: var(--info-surface);
  color: var(--text);
  font-size: var(--font-size-13);
}

.help {
  margin: 0;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.refusal {
  margin: 0;
  color: var(--danger-text);
  font-size: var(--font-size-13);
}

.actions {
  display: flex;
  gap: var(--space-2);
}

.links {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding-block-start: var(--space-3);
  border-top: 1px solid var(--border);
}

.subtitle {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-semibold);
}

.foot {
  padding: 10px var(--space-4);
  border-top: 1px solid var(--border);
  font-size: var(--font-size-13);
}

.manage {
  color: var(--action-text);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
}

.arrow {
  margin-inline-start: var(--space-1);
}

.manage:hover {
  text-decoration: underline;
}

.manage:focus-visible {
  border-radius: var(--radius-small);
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
